export enum LabelType {
    Default,
    Error,
    Warning,
    Success,
    Update
}
